/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BrandScreen from '@/screens/setting/brand/BrandScreen';
import BrandDetailScreen from '@/screens/setting/brand/BrandDetailScreen';

const Stack = createStackNavigator();

const BrandNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  return (
    <Stack.Navigator
      initialRouteName="BrandScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="BrandScreen"
        component={BrandScreen}
        options={(props) => ({
          title: setTitleHeader('Brand'),
        })}
      />
      <Stack.Screen
        name="BrandDetailScreen"
        component={BrandDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Edit Brand';
          if (route.params?.id == 'add') {
            title = 'Add Brand';
          } else if (route.params?.id == 'view') {
            title = 'View Brand';
          }
          return {
            title: setTitleHeader(title),
            headerRight: () => false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

BrandNavigator.propTypes = {
  navigation: PropTypes.object,
};

BrandNavigator.defaultProps = {
  navigation: {},
};

export default BrandNavigator;
